import * as React from 'react'
import search from '../../assets/search.svg'

interface SearchfieldProps {
  value: string
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
  style?: React.CSSProperties
}

const Searchfield: React.SFC<SearchfieldProps> = ({ value, onChange, style }) => {
  return (
    <div style={{ position: 'relative', width: '100%', ...style }}>
      <input
        placeholder="Suche..."
        value={value}
        onChange={onChange}
        style={{ paddingLeft: '10px', width: '100%', height: '40px' }}
      />
      <img src={search} style={{ width: '20px', height: '20px', position: 'absolute', right: '10px', top: '10px' }} />
    </div>
  )
}

export default Searchfield



// WEBPACK FOOTER //
// ./src/components/search/Searchfield.tsx